import { z } from 'zod';
import { CountryCodeSchema } from '@/modules/location/components/phoneinput/CountryCodes.ts';

export const PhoneSchema = z.object({
    number: z.string(),
    countryCode: CountryCodeSchema,
});
